import { Component, Input, forwardRef, ChangeDetectionStrategy, OnInit, Output, EventEmitter } from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  NG_VALIDATORS,
  FormControl,
  RequiredValidator,
  Validator,
  ValidationErrors,
} from '@angular/forms';

import { NbComponentSize, NbComponentShape, NbComponentStatus } from '@nebular/theme';

@Component({
  selector: 'bf-tags-input',
  templateUrl: './tags-input.component.html',
  styleUrls: ['./tags-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TagsInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TagsInputComponent),
      multi: true,
    },
  ],
})
export class TagsInputComponent implements OnInit, Validator {
  input: FormControl = new FormControl();
  value: string[] = [];

  onChange: Function = (value?: any) => {};
  onTouched: Function = () => {};
  protected onValidationChange: Function = () => {};

  @Input() size: NbComponentSize = 'medium';
  @Input() status: NbComponentStatus = 'basic';
  @Input() shape: NbComponentShape = 'rectangle';
  @Input() type: string = 'text';
  @Input() fullWidth: boolean = false;
  @Input() maxLength?: number;
  @Output() tagsChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  lengthError: boolean = false;

  get tags(): string[] {
    return this.value;
  }
  set tags(value: string[]) {
    if (value !== this.value) {
      this.value = value;
      if (this.onChange) {
        this.onChange(this.value);
      }
      if (this.onValidationChange) {
        this.onValidationChange(this.value);
      }
    }
  }

  get cssClasses(): string[] {
    return [
      `size-${this.size}`,
      `status-${this.status}`,
      `shape-${this.shape}`,
      `${this.fullWidth ? 'input-full-width' : ''}`,
    ];
  }

  constructor() {}

  ngOnInit() {
    /*if(this.control){
            this.input.setValidators(this.control.validator);
        }        */
  }

  writeValue(value: string | string[]): void {
    const values = Array.isArray(value) ? value : [value];
    this.tags = values.filter((tag: string) => tag !== '');
    /*if(this.control){
            this.control.setValue(this.tags);
        } */
  }

  onAddClick(): void {
    const input = this.input.value;
    if (input) {
      if (this.maxLength && input.length > this.maxLength) {
        this.lengthError = true;
        return;
      }
      if (this.tags.indexOf(input) === -1) {
        this.tags = this.tags.concat(input);
        this.tagsChange.emit(this.tags);
      }
    }
    this.lengthError = false;
    this.input.setValue('');
  }

  validate(c: FormControl): ValidationErrors {
    const isEmpty = c.errors && c.errors.required && this.tags.length === 0;
    return isEmpty ? { isRequired: true } : undefined;
  }

  onKeyEnter(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const tag = input.value;
    if (tag) {
      if (this.maxLength && tag.length > this.maxLength) {
        this.lengthError = true;
        return;
      }
      if (this.tags.indexOf(tag) === -1) {
        this.tags = this.tags.concat(tag);
        this.tagsChange.emit(this.tags);
      }
    }
    this.lengthError = false;
    input.value = '';
  }

  deleteTag(tag: string) {
    this.tags = this.tags.filter((current: string) => current !== tag);
    this.tagsChange.emit(this.tags);
  }
}
